export const mergeLine = (values, size = values.length) => {
  const compact = values.filter(Boolean);
  let gained = 0;
  for (let index = 0; index < compact.length - 1; index += 1) {
    if (compact[index] === compact[index + 1]) {
      compact[index] *= 2;
      gained += compact[index];
      compact.splice(index + 1, 1);
    }
  }
  while (compact.length < size) compact.push(0);
  return { line: compact, gained };
};

export const isValidPathMove = ({ current, next, size, blocked, path }) => {
  if (blocked[next] || path.includes(next)) return false;
  const row = Math.floor(next / size);
  const col = next % size;
  const currentRow = Math.floor(current / size);
  const currentCol = current % size;
  return Math.abs(row - currentRow) + Math.abs(col - currentCol) === 1;
};

export const resolveStrategyTurn = ({ hp, position, attackers, gate = 6 }) => {
  const remainingHp = hp - attackers;
  if (remainingHp <= 0) return { outcome: "defeated", hp: 0, position };
  const nextPosition = position + 1;
  if (nextPosition >= gate) return { outcome: "breached", hp: remainingHp, position: nextPosition };
  return { outcome: "advanced", hp: remainingHp, position: nextPosition };
};

export const findMatchCells = (board, size) => {
  const matches = new Set();
  for (let row = 0; row < size; row += 1) {
    let run = 1;
    for (let col = 1; col <= size; col += 1) {
      const current = col < size ? board[row * size + col] : null;
      const previous = board[row * size + col - 1];
      if (current && current === previous) run += 1;
      else {
        if (previous && run >= 3) for (let offset = 1; offset <= run; offset += 1) matches.add(row * size + col - offset);
        run = 1;
      }
    }
  }
  for (let col = 0; col < size; col += 1) {
    let run = 1;
    for (let row = 1; row <= size; row += 1) {
      const current = row < size ? board[row * size + col] : null;
      const previous = board[(row - 1) * size + col];
      if (current && current === previous) run += 1;
      else {
        if (previous && run >= 3) for (let offset = 1; offset <= run; offset += 1) matches.add((row - offset) * size + col);
        run = 1;
      }
    }
  }
  return [...matches];
};

export const ticTacToeWinner = (board) => {
  const lines = [[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8],[0,4,8],[2,4,6]];
  const line = lines.find(([a, b, c]) => board[a] && board[a] === board[b] && board[a] === board[c]);
  return line ? board[line[0]] : board.every(Boolean) ? "draw" : null;
};

export const clearCompletedLines = (board, size = 8) => {
  const rows = Array.from({ length: size }, (_, row) => row).filter((row) =>
    Array.from({ length: size }, (_, col) => board[row * size + col]).every(Boolean)
  );
  const columns = Array.from({ length: size }, (_, col) => col).filter((col) =>
    Array.from({ length: size }, (_, row) => board[row * size + col]).every(Boolean)
  );
  const next = board.map((value, index) => rows.includes(Math.floor(index / size)) || columns.includes(index % size) ? 0 : value);
  return { board: next, lines: rows.length + columns.length };
};
